import PropTypes from "prop-types"
import React from "react"

import BoatPicker from "./BoatPicker"

class SelectBoat extends React.Component {
  constructor(props) {
    super(props)
    this.newBoat = this.newBoat.bind(this)
    this.nextButton = this.nextButton.bind(this)
  }

  componentDidMount() {
    this.props.setHeader("Select Boat")
  }

  nextButton() {
    this.props.setGlobalState({ boatCreated: "previously" })
    this.props.routeTo("next")
  }

  newBoat() {
    this.props.setGlobalState({ boatCreated: "now" })
    this.props.routeTo("AddBoatPageOne")
  }

  render() {
    return (
      <div id="selectBoat" className="select-boat">
        <BoatPicker
          state={this.props.state}
          setGlobalState={this.props.setGlobalState}
          selectBoatPage={true}
          newBoat={this.newBoat}
        />
        <button
          id="selectBoatButton"
          type="button"
          className="btn btn-primary"
          onClick={this.nextButton}
        >
          Select Boat
        </button>
        <button
          id="newBoatButton"
          type="button"
          className="btn btn-secondary"
          onClick={this.newBoat}
        >
          Add New Boat
        </button>
      </div>
    )
  }
}

SelectBoat.propTypes = {
  state: PropTypes.object.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  setHeader: PropTypes.func.isRequired,
}

export default SelectBoat
